import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { DragAndDroppable } from 'owa-dnd';
import type { SubTaskViewProps } from '../schema';
import SubTaskView from './SubTaskView';
import useSubTaskDraggableViewState from '../hooks/useSubTaskDraggableViewState';

export default observer(function SubTaskViewDraggable(props: SubTaskViewProps) {
    const { droppableProps, draggableProps } = useSubTaskDraggableViewState(props);
    return (
        <DragAndDroppable
            {...droppableProps}
            {...draggableProps}
            classNames={classNames(styles.droppableSubtask, {
                [styles.dropHint]:
                    droppableProps.dropViewState.isDragOver &&
                    !draggableProps.dragViewState.isBeingDragged,
            })}
            preventBubblingDragEvents={true}>
            <SubTaskView {...props} />
        </DragAndDroppable>
    );
});
